import type { ProductAnalysis, ProductAnalysisRunState } from '@ozon-ai/analysis/contracts';

export function isProductAnalysisRunState(
  value: ProductAnalysis | ProductAnalysisRunState
): value is ProductAnalysisRunState {
  return 'kind' in value && value.kind === 'run';
}
